import Reveal from "@/components/base/Reveal";
import { homeStats } from "@/mocks/siteData";

export default function StatsStrip() {
  return (
    <section className="w-full px-4 md:px-8 -mt-10 md:-mt-14 relative z-20">
      <div className="max-w-content mx-auto">
        <Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-background-200 border border-background-200 rounded-lg overflow-hidden">
            {homeStats.map((stat) => (
              <div key={stat.id} className="bg-background-50 px-6 py-7">
                <p className="font-heading text-3xl md:text-4xl font-bold text-primary-600">
                  {stat.value}
                </p>
                <p className="mt-2.5 text-sm font-medium text-foreground-900">{stat.label}</p>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{stat.note}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}